import { mergeClassnames } from '@heathmont/moon-core-tw';
import type { RegisterOptions } from 'react-hook-form';
import useAgentData from '~/client/hooks/useAgentData';
import usePhoneFields from './hooks/usePhoneFields';
import FormInput from '../FormInput';
import FormSelect from '../FormSelect';

type Props = {
  value: string;
  onChange: (phoneString: string) => void;
  error?: string;
  rules?: RegisterOptions;
  label?: string;
};

const PhoneFields = ({ onChange, value, label, error }: Props) => {
  const { isMobile } = useAgentData();

  const {
    countryCode,
    phoneNumber,
    primaryOptions,
    secondaryOptions,
    handleCodeChange,
    handleNumberChange,
  } = usePhoneFields({ value, onChange });

  return (
    <div
      className={mergeClassnames(
        'grid grid-flow-col grid-cols-[max-content_1fr] items-end gap-4',
        isMobile && 'grid-cols-2',
      )}
    >
      <FormSelect
        label="profile.country_code"
        options={[...primaryOptions, ...secondaryOptions]}
        onChange={handleCodeChange}
        data-testid="countryCode"
        value={countryCode}
        enableEmptyValue
        error={error}
        skipErrorMessage
      />
      <FormInput
        type="tel"
        label={label || 'profile.phone'}
        data-testid="phone"
        value={phoneNumber}
        onChange={handleNumberChange}
        error={error}
        skipErrorMessage
      />
    </div>
  );
};

export default PhoneFields;
